export const TemplateType = Object.freeze({
  EMAIL: 'email',
  SMS: 'sms',
  TEXT: 'text',
  ELECTRONIC_INVOICE_EMAIL: 'einvoiceEmail',
});

export const TemplateDocumentLevel = Object.freeze({
  HEADER: 'header',
  LINE: 'line',
});
